// Fault attribution for a decline - lets ops tag WHOSE fault a cancellation
// was, and feeds the CUSTOMER_NO_SHOW recovery campaign when a decline is
// tagged CUSTOMER_FAULT / NO_SHOW specifically (not every decline).
export const DECLINE_CATEGORIES = [
  { value: "", label: "Select fault category" },
  { value: "CUSTOMER_FAULT", label: "Customer" },
  { value: "EMPLOYEE_FAULT", label: "Employee" },
  { value: "ADMIN_FAULT", label: "Admin / Ops" },
];

export const DECLINE_REASONS = {
  CUSTOMER_FAULT: [
    { value: "", label: "Select reason" },
    { value: "NO_SHOW", label: "Customer no-show / unavailable" },
    { value: "WRONG_ADDRESS", label: "Incorrect / unreachable address" },
    { value: "CHANGED_MIND", label: "Customer changed mind" },
    { value: "OTHER", label: "Other" },
  ],
  EMPLOYEE_FAULT: [
    { value: "", label: "Select reason" },
    { value: "RUNNING_LATE", label: "Running late / no-show" },
    { value: "PERSONAL_EMERGENCY", label: "Personal emergency" },
    { value: "UNABLE_TO_PERFORM", label: "Unable to perform service" },
    // Set automatically when the professional declines from the employee
    // app (reason "Not available" / "Stock not available").
    { value: "EMPLOYEE_UNAVAILABLE", label: "Professional not available" },
    { value: "STOCK_UNAVAILABLE", label: "Stock not available" },
    { value: "OTHER", label: "Other" },
  ],
  ADMIN_FAULT: [
    { value: "", label: "Select reason" },
    { value: "NO_EMPLOYEE_AVAILABLE", label: "No employee available" },
    { value: "SERVICE_AREA_ISSUE", label: "Service area / logistics issue" },
    { value: "PRICING_ERROR", label: "Pricing / booking error" },
    { value: "OTHER", label: "Other" },
  ],
};

// UNSPECIFIED covers declines recorded before decline_category/decline_reason
// existed, or where an admin skipped the fields - keeps counts/columns from
// silently dropping older rows.
export const DECLINE_CATEGORY_LABELS = {
  ...DECLINE_CATEGORIES.reduce((acc, c) => {
    if (c.value) acc[c.value] = c.label;
    return acc;
  }, {}),
  UNSPECIFIED: "Unspecified",
};

export const DECLINE_REASON_LABELS = Object.values(DECLINE_REASONS)
  .flat()
  .reduce((acc, r) => {
    if (r.value) acc[r.value] = r.label;
    return acc;
  }, { UNSPECIFIED: "Unspecified" });
